import { render } from "./BaseCurrencyInput.vue?vue&type=template&id=20bdab1e"
import script from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
export * from "./BaseCurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script